import React from "react";
import PT from "prop-types";
import { object } from "prop-types";
import get from "lodash/get";
import { StoryElement, WithLazy } from "@quintype/components";
import { ImageGalleryElement } from "../../../story-elements";
import { isNonEmptyNode } from "../../../utils/story";
import CustomStoryElement from "../../custom-story-elements";
import { ImageSlideshow } from "../../custom-story-elements/slideshow";
import { CustomTextElement } from "../../custom-story-elements/text-element";
import { Attachment } from "../../custom-story-elements/attachment";
import "./gn-reach-template.m.css";

function GNReachStoryElements({ element, story }) {
  const { type, subtype, metadata } = element;
  if (type === "composite" && subtype === "image-gallery" && metadata.type === "gallery") {
    return (
      <ImageGalleryElement
        story={story}
        widths={[132, 242]}
        element={element}
        key={element.id}
        imageAspectRatio={[1, 1]}
      />
    );
  }
  if (type === "composite" && metadata.type === "slideshow") {
    <WithLazy margin="50px" key={element.id}>
      {() => <ImageSlideshow key={element.id} element={element} story={story} />}
    </WithLazy>;
  }
  if (type === "jsembed" || type === "youtube-video") {
    return (
      <WithLazy margin="50px" key={element.id}>
        {() => <StoryElement element={element} key={element.id} story={story} loadIframeOnClick />}
      </WithLazy>
    );
  }
  if (type === "text" && subtype === null) {
    return <CustomTextElement element={element} story={story} />;
  }
  if (type === "file" && subtype === "attachment") {
    return <Attachment element={element} key={element.id} />;
  }
  return <StoryElement element={element} key={element.id} story={story} loadIframeOnClick />;
}

GNReachStoryElements.propTypes = {
  card: object,
  story: object,
};

function GnReachImageCard({ element }) {
  return (
    <WithLazy margin="50px" key={element.id}>
      {() => (
        <StoryElement
          element={{
            ...element,
            "image-attribution": isNonEmptyNode(element["image-attribution"]),
            title: isNonEmptyNode(element.title),
          }}
          key={element.id}
          loadIframeOnClick
        />
      )}
    </WithLazy>
  );
}

export default function StoryCard({ card, story }) {
  const attribute = get(card, ["metadata", "attributes", "cardtype", "0"], null);
  const bigImageStyle = attribute === "Big_Image" ? "full-width-div" : "story-bottom-div";
  if (attribute) {
    return (
      <div styleName={bigImageStyle}>
        <CustomStoryElement card={card} attribute={attribute} story={story} />
      </div>
    );
  } else {
    return card["story-elements"].map((element) => {
      return element.type !== "image" ? (
        <div styleName="story-bottom-div" key={element.id}>
          <GNReachStoryElements element={element} story={story} />
        </div>
      ) : (
        <div styleName="gn-reach-image-element" key={element.id}>
          <GnReachImageCard element={element} />
        </div>
      );
    });
  }
}

StoryCard.propTypes = {
  card: PT.object,
  story: PT.object,
};
